module.exports = __webpack_public_path__ + "static/media/login.02da0afa.svg";